export const PRIVACY_POLICY = 'https://e.vhall.com/v3/privacyPolicy'; // 隐私政策
export const PRIVACY_UPO = 'https://e.vhall.com/v3/privacyUPo'; // 用户保护协议
